// import {  useEffect, useState } from "react";
import { useEffect, useState } from 'react';
import bot from '../images/happy.png'
import Details from './Details';
import PropertyType from './PropertyType';
import LoadingDots from './LoadingDots';
// import LoadingDots from "./LoadingDots";
const Greetings = () => {
    const [time] = useState(new Date());


    const getGreeting = () => {
        const hours = time.getHours();
        if (hours < 12) return "Good Morning";
        if (hours < 18) return "Good Afternoon";
        return "Good Evening";
      };
      const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching data
    setTimeout(() => setLoading(false), 1000); 
  }, []);
    return(
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
            <div className="frame1">
            <b>Akaay Infra: </b>{getGreeting()}, Greetings from Akaay Infra<br/>
            </div>
            <div className="frame1">
            Akaay Infra is an innovation based real estate design and development company: 
            a standing testimony of 'Think Global - Act Local' that is set to revolutionize 
            the real esatate sector in Hyderabad.
            </div>
            
              
            
            
            <Details />
            {/* <PropertyType /> */}
        </>
    );
}
export default Greetings;